import { useField } from "formik"
import classNames from "classnames"
import { useAnimation } from "utils/useAnimation"

const Checkbox = ({ label, text, helperText, ...props }) => {
  // const [field, meta] = useField({ ...props, type: "checkbox" })

  const [field, { error, touched }, { setValue }] = useField({ ...props, type: "checkbox" })

  const { variants } = useAnimation()

  return (
    <div className={classNames("space-y-3 text-lg border-b border-grey-600", error && touched && "!border-red-500")}>
      <div className="font-medium">{label}</div>
      <label className="grid grid-cols-[1rem_minmax(0,1fr)_4.5rem] gap-x-3 items-start cursor-pointer pb-3">
        <input
          type="checkbox"
          {...field}
          {...props}
          className={classNames(
            "mt-1 h-4 w-4 rounded border-grey-600 text-primary-600 focus:ring-primary-500",
            error && touched && "!border-red-500"
          )}
        />
        <div className="flex flex-col -mt-0.5 min-w-0">
          <span
            className={classNames("text-lg font-medium user-select-none", error && touched && "!text-red-500")}
            style={{ userSelect: "none" }}
          >
            {text}
          </span>
          {helperText && <span className="text-sm text-grey-400 mt-1">{helperText}</span>}
        </div>
        <div className="pt-0.5 text-right">
          <span
            className={classNames("text-red-500 text-sm font-semibold whitespace-nowrap", !(error && touched) && "invisible")}
            aria-hidden={!(error && touched)}
          >
            {error || "Required"}
          </span>
        </div>
      </label>
    </div>
  )
}

export default Checkbox
